import {
  Anchor,
  Container,
  Divider,
  Grid,
  Group,
  Stack,
  Text,
  Title,
  useMantineTheme,
} from "@mantine/core";
import { IconBrandWhatsapp, IconMail } from "@tabler/icons-react";
import React from "react";
import { Link } from "react-router-dom";
import { buildWhatsAppUrl } from "../Services/contact.service";
import { servicePages } from "../data/servicePages";
import SubjectBuddyLogo from "./Shared/SubjectBuddyLogo";

function Footer() {
  const theme = useMantineTheme();
  const siteName = process.env.REACT_APP_NAME || "SubjectBuddy";
  const email = process.env.REACT_APP_EMAIL;
  const whatsappUrl = buildWhatsAppUrl("Hi, I need help from SubjectBuddy.");

  return (
    <footer style={{ background: theme.colors.dark[8], marginTop: "5rem" }}>
      <Container py={50}>
        <Grid>
          <Grid.Col span={{ base: 12, md: 4 }}>
            <Stack gap={10}>
              <SubjectBuddyLogo size={30} />
              <Text c="gray.5" size="sm">
                Your trusted platform to find a personal tutor for ethical
                academic growth and lasting learning skills.
              </Text>
            </Stack>
          </Grid.Col>

          <Grid.Col span={{ base: 12, md: 4 }}>
            <Stack gap={20}>
              <Title order={2} c="white" style={{ fontSize: "1.2rem" }}>
                Contact Us
              </Title>
              <Stack gap={10}>
                {email ? (
                  <Group gap={10}>
                    <IconMail color="white" />
                    <Text c="gray.5" size="sm">
                      {email}
                    </Text>
                  </Group>
                ) : null}
                {whatsappUrl !== "#" ? (
                  <Group gap={10}>
                    <IconBrandWhatsapp color="white" />
                    <Anchor
                      href={whatsappUrl}
                      target="_blank"
                      rel="noreferrer"
                      c="gray.5"
                      size="sm"
                    >
                      Chat with us on WhatsApp
                    </Anchor>
                  </Group>
                ) : null}
                <Text c="gray.5" size="sm">
                  Supporting students in the US, UK, Canada, and beyond.
                </Text>
              </Stack>
            </Stack>
          </Grid.Col>

          <Grid.Col span={{ base: 12, md: 4 }}>
            <Stack gap={20}>
              <Title order={2} c="white" style={{ fontSize: "1.2rem" }}>
                Explore
              </Title>
              <Stack gap={10}>
                <Anchor component={Link} to="/about-us" c="gray.5" size="sm">
                  About SubjectBuddy
                </Anchor>
                <Anchor component={Link} to="/assignment-help" c="gray.5" size="sm">
                  Assignment help by subject
                </Anchor>
                <Anchor component={Link} to="/blogs" c="gray.5" size="sm">
                  Student guides and blog articles
                </Anchor>
                <Anchor component={Link} to="/reviews" c="gray.5" size="sm">
                  Student reviews and trust signals
                </Anchor>
                <Anchor component={Link} to="/tools" c="gray.5" size="sm">
                  Free student tools
                </Anchor>
                <Anchor
                  component={Link}
                  to="/tools/cursive-generator"
                  c="gray.5"
                  size="sm"
                >
                  Cursive Generator
                </Anchor>
                <Anchor
                  component={Link}
                  to="/tools/semester-grade-calculator"
                  c="gray.5"
                  size="sm"
                >
                  Semester Grade Calculator
                </Anchor>
                <Anchor component={Link} to="/tools/grade-calculator" c="gray.5" size="sm">
                  Grade Calculator
                </Anchor>
                <Anchor
                  component={Link}
                  to="/tools/midterm-grade-calculator"
                  c="gray.5"
                  size="sm"
                >
                  Midterm Grade Calculator
                </Anchor>
                <Anchor
                  component={Link}
                  to="/tools/final-grade-calculator"
                  c="gray.5"
                  size="sm"
                >
                  Final Grade Calculator
                </Anchor>
                <Anchor
                  component={Link}
                  to="/tools/letter-grade-calculator"
                  c="gray.5"
                  size="sm"
                >
                  Letter Grade Calculator
                </Anchor>
                <Anchor
                  component={Link}
                  to="/tools/cumulative-gpa-calculator"
                  c="gray.5"
                  size="sm"
                >
                  Cumulative GPA Calculator
                </Anchor>
                <Anchor
                  component={Link}
                  to="/tools/ai-college-essay-reviewer"
                  c="gray.5"
                  size="sm"
                >
                  AI College Essay Reviewer
                </Anchor>
                <Anchor
                  component={Link}
                  to="/tools/college-essay-editor"
                  c="gray.5"
                  size="sm"
                >
                  College Essay Editor
                </Anchor>
                <Anchor
                  component={Link}
                  to="/tools/speech-word-counter"
                  c="gray.5"
                  size="sm"
                >
                  Speech Word Counter
                </Anchor>
                <Anchor
                  component={Link}
                  to="/tools/speech-time-calculator"
                  c="gray.5"
                  size="sm"
                >
                  Speech Time Calculator
                </Anchor>
                <Anchor
                  component={Link}
                  to="/tools/racine-carree-calculator"
                  c="gray.5"
                  size="sm"
                >
                  Racine Carrée Calculator
                </Anchor>
                <Anchor
                  component={Link}
                  to="/tools/ap-bio-score-calculator"
                  c="gray.5"
                  size="sm"
                >
                  AP Bio Score Calculator
                </Anchor>
                <Anchor
                  component={Link}
                  to="/tools/apush-score-calculator"
                  c="gray.5"
                  size="sm"
                >
                  APUSH Score Calculator
                </Anchor>
                {servicePages.map((service) => (
                  <Anchor
                    key={service.slug}
                    component={Link}
                    to={`/services/${service.slug}`}
                    c="gray.5"
                    size="sm"
                  >
                    {service.navLabel}
                  </Anchor>
                ))}
              </Stack>
            </Stack>
          </Grid.Col>
        </Grid>

        <Divider my={30} color="gray.7" />

        <Group justify="space-between">
          <Text size="xs" c="dimmed">
            Copyright 2025 {siteName}. All rights reserved.
          </Text>
          <Group gap={15}>
            <Text component={Link} to="/terms-of-service" size="xs" c="dimmed">
              Terms of Service
            </Text>
            <Text component={Link} to="/privacy-policy" size="xs" c="dimmed">
              Privacy Policy
            </Text>
          </Group>
        </Group>
      </Container>
    </footer>
  );
}

export default Footer;
